import * as React from "react";

function SvgIcExpenses(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.874v4.252A4.007 4.007 0 016.874 17h10.252A4.007 4.007 0 0120 14.126V9.874A4.007 4.007 0 0117.126 7H6.874A4.007 4.007 0 014 9.874zM2 6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm10.856 7.437c-.142.122-.352.198-.631.228l.134-1.306c.102.03.197.062.284.097a.97.97 0 01.225.122.497.497 0 01.15.163c.037.06.055.13.055.212 0 .199-.072.36-.217.484zm-1.258-3.086c.102-.037.227-.062.374-.077l-.122 1.19a3.03 3.03 0 01-.276-.103 1.213 1.213 0 01-.22-.128.65.65 0 01-.147-.164.487.487 0 01-.008-.417.503.503 0 01.146-.173.84.84 0 01.253-.128zm1.4 1.424c-.187-.057-.375-.11-.564-.157l.138-1.328c.103.02.196.044.28.074.087.03.164.06.233.09l.185.073c.055.02.103.03.142.03.053 0 .097-.011.134-.033a.392.392 0 00.107-.096l.236-.292a2.564 2.564 0 00-.524-.311 2.469 2.469 0 00-.722-.196L12.706 9h-.359a.275.275 0 00-.185.061.209.209 0 00-.08.138l-.043.404a2.59 2.59 0 00-.769.135c-.223.08-.413.18-.568.302-.152.122-.268.26-.347.417a1.03 1.03 0 00-.118.475c0 .218.044.4.134.545.09.146.206.266.35.363.148.094.313.17.494.227.184.058.37.108.556.151l-.146 1.434a1.59 1.59 0 01-.382-.1 4.223 4.223 0 01-.288-.13 7.123 7.123 0 00-.225-.116.404.404 0 00-.186-.051.325.325 0 00-.244.109l-.3.362c.19.152.42.28.69.382.271.103.56.171.868.205l-.07.687h.358a.26.26 0 00.182-.064c.05-.04.076-.086.079-.135l.047-.472c.294-.015.556-.064.785-.147.229-.086.422-.195.58-.328.158-.134.277-.288.359-.461.081-.176.122-.363.122-.562a.857.857 0 00-.138-.5 1.143 1.143 0 00-.363-.337 2.117 2.117 0 00-.501-.219z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcExpenses;
